import { getWalletCount } from '../api/api'
import { ReactComponent as ArrowUp } from '../assets/icons/arrowUp.svg'
import { useQuery } from 'react-query'
import { TConnectionTime, TimeRange, WalletStats } from '../api/model'
import Loader from './Loading'
import { USDDollarFormatter } from '../utils/util'
import useCustomStore from '../hooks/useCustomStore'
import { cn } from '../utils/helpers/helper'

const Statistics = () => {
  const { selectedOption, title } = useCustomStore()
  
  const { data, isLoading } = useQuery<WalletStats>(
    ['totalWallet' , title.value , selectedOption ],
    async () => await getWalletCount({
      date : title.value as TimeRange, 
      connectionTime : selectedOption as TConnectionTime
    }),
  )
console.log(data)
  const statValues = [
    {
      name: 'Total Users',
      value: data && data.TotalUsers,
      colorWhite: true,
    },
    {
      name: 'Total NettyWorth',
      value: data && USDDollarFormatter(data.TotalNettyWorth, 'USD'),
    },
    {
      name: 'Total Crypto Value',
      value: data && USDDollarFormatter(data.TotalCryptoValue, 'USD'),
    },
    {
      name: 'Total NFT Value',
      value: data && USDDollarFormatter(data.TotalNFTValue, 'USD'),
    },
  ]
  return (
    <div className='pt-5'>
      <div className='flex gap-6 justify-center items-center font-inter'>
        {!isLoading ? (
          statValues.map((stat) => {
            return (
              <div
                key={stat.name}
                className='flex flex-col rounded bg-jet-black-100 py-4 min-w-[200px] px-[22px]'
              >
                <span className='text-base font-medium'>{stat.name}</span>
                <p className={cn('text-xl font-semibold leading-8', !stat.colorWhite && 'text-forest-green')}>{stat.value}</p>
              </div>
            )
          })
        ) : (
          <Loader />
        )}
      </div>
    </div>
  )
}

export default Statistics
